/*
 * @author Sergey Kuzhavskiy <Praffesor>
 */
angular.module('popup.email', ['popup', 'data.email']);
